/**
 * Created by michale on 09.03.17.
 */

import React from 'react';
import PropTypes from 'prop-types';

import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';

const ConfirmSavePeriodicEventDialog = (props) => (
    <Dialog
        title="Confirm save event"
        actions={[
            <FlatButton key="cancel" label="Cancel" secondary={true} onTouchTap={props.onClose} />
        ]}
        modal={true}
        open={props.open}
        onRequestClose={props.onClose}
    >
        <table style={{ textAlign: 'center' }}>
            <tbody>
            <tr>
                <td><FlatButton label="Save this instance" onTouchTap={props.onSaveCurrent}/></td>
                <td><FlatButton label="Save all the following" primary={true} onTouchTap={props.onSaveFollowing}/></td>
                <td><FlatButton label="Save all events series" secondary={true} onTouchTap={props.onSaveAll}/></td>
            </tr>
            <tr>
                <td>All other events in the series will remain the same</td>
                <td>This and all the following events will be changed.</td>
                <td>All events in the series will be changed.</td>
            </tr>
            </tbody>
        </table>
    </Dialog>
);


ConfirmSavePeriodicEventDialog.propTypes = {
    onSaveCurrent: PropTypes.func.isRequired,
    onSaveFollowing: PropTypes.func.isRequired,
    onSaveAll: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired
};

export default ConfirmSavePeriodicEventDialog;
